var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1413,
    height: 588,
    viewBox: "0 0 1413 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4028 486.659L26.8486 497.08L69.8099 585.934L91.3641 575.512L48.4028 486.659Z",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5454 497.32L42.7734 502.527",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5031 517.907L52.7236 523.121",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4572 538.492L62.6777 543.706",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4048 559.085L72.6328 564.291",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8421 504.137L51.4561 506.736",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1682 511.022L54.7822 513.629",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8128 524.759L61.4268 527.358",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.138 531.645L64.752 534.251",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7844 545.383L71.3984 547.982",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1171 552.266L74.7236 554.872",
    stroke: "#63D6BA",
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6416 103.57L55.6045 90.6074L19.6852 54.6882L6.72236 67.6511L42.6416 103.57Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1062 107.078L55.5972 90.6055L42.6338 103.569L59.1062 107.078Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4698 99.3896L51.416 105.438",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90069 57.7687L9.79317 50.8763C11.4706 49.1988 14.1866 49.1988 15.8641 50.8763L19.6755 54.6877L6.7121 67.651L2.90069 63.8396C1.22321 62.1621 1.22321 59.4405 2.90069 57.7687Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1782 58.1865L10.2148 71.1556",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1162 97.085L16.6963 64.6709",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.24729,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.4 34.7544L1349.01 40.1926",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.72 42.351L1366.33 47.7893",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.04 49.9438L1383.65 55.382",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.81 29.6701L1338.61 32.3936",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.6 32.2151L1344.41 34.9299",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.16 37.2794L1355.97 40.0029",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.95 39.8196L1361.76 42.5391",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.51 44.8869L1373.32 47.6104",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.11 52.6067L1390.93 55.3262",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.3 47.427L1379.11 50.1465",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.29 96.0913L1325.11 23.2271L1399.87 56.0046L1382.29 96.0913Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.38 73.0936L1363.73 53.1603L1384.18 62.1231L1379.38 73.0936Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.6,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M939.57 107.352L916.175 118.341C914.924 118.933 913.434 118.394 912.842 117.143L911.344 113.952C910.752 112.701 911.291 111.21 912.542 110.618L935.937 99.629C937.188 99.0372 938.678 99.5766 939.27 100.828L940.768 104.019C941.36 105.277 940.821 106.768 939.57 107.352Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.4,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M948.656 132.311L937.21 108.475L918.692 117.366L930.139 141.203L937.36 181.084C939.735 186.036 945.675 188.118 950.619 185.744L970.612 176.14C975.564 173.766 977.646 167.825 975.272 162.881L948.656 132.311Z",
    stroke: "#63D6BA",
    strokeOpacity: 0.4,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M933.389 159.188C933.389 159.188 937.209 153 947.367 153.352C957.525 153.704 959.232 144.453 959.232 144.453",
    stroke: "#63D6BA",
    strokeOpacity: 0.4,
    strokeWidth: 2.99638,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcons);
export default __webpack_public_path__ + "static/media/banner-icons.bd9712ec484a76399e993a0ad4bfda0f.svg";
export { ForwardRef as ReactComponent };